/**
 * Which repo the app edits. Overridable at build time so moving the data repo into
 * an organization is a Cloudflare env-var change, not a code change.
 *
 * Set VITE_REPO_OWNER / VITE_REPO_NAME in the Pages project to point elsewhere.
 */
export const REPO_OWNER = import.meta.env.VITE_REPO_OWNER ?? 'KingsmithMobile'
export const REPO_NAME = import.meta.env.VITE_REPO_NAME ?? 'kingsmith-questdata'
export const DEFAULT_BRANCH = import.meta.env.VITE_REPO_BRANCH ?? 'main'
export const API_ROOT = 'https://api.github.com'
